var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"dropdown",staticClass:"dropdown"},[_c('div',{staticClass:"dropdown__button-wrapper",on:{"click":_vm.toggleDropdownVisibility}},[_vm._t("button")],2),_c('ul',{ref:"scrollableDropdown",staticClass:"dropdown-menu main-dropdown scrollable-dropdown",class:_vm.dropdownMenuClasses},[_vm._t("list-elements")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }